import { Component, OnInit, OnDestroy, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../@core/service/api.service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { CoreModel } from '../../../@models/erp/core';
import { FinishedProductModel, EProductType, FpEnergy, FpContent, FinishedProductStatus, EBoxLabelPriority }
  from '../../../@models/erp/finishedProduct';
import { BaseProductModel, DownloadType } from '../../../@models/erp/baseProduct';
import { BusinessField, BusinessModel } from '../../../@models/business';
import { BoxLabelPriorityData, BusinessUnitUtil, CountryCodes, IssuerData } from '../../../@models/erp/compilationData';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialModel } from '../../../@models/material';
import { BusinessUnitModel } from '../../../@models';
import { AbstractProduct } from '../abstractProduct';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { EWizardAction, ProductWizardComponent, WizardAction } from '../product-wizard/product-wizard.component';
import { mongoId, waitForVariable } from '../../../@core/common/global';
import { CompilationModel } from '../../../@models/erp/compilation';
import { SharedDataService } from '../../../@core/service/shared-data.service';

@Component({
  selector: 'ngx-erp-finished-product',
  templateUrl: './finished-product.component.html',
  styleUrls: ['./finished-product.component.scss'],
})
export class FinishedProductComponent extends AbstractProduct<FinishedProductModel> implements OnInit, OnChanges {

  @Input() fromWizard: ProductWizardComponent = null;
  @Input() baseProduct: BaseProductModel;
  @Input() finishedProduct: FinishedProductModel;
  @Input() compilation: CompilationModel;
  @Output() wizardAction = new EventEmitter<WizardAction>()

  // finishedProduct: Observable<FinishedProductModel[]>;
  items: FinishedProductModel[];
  selected: FinishedProductModel;
  displayItems = [];

  // cores: CoreModel[];
  // businessUnits: BusinessUnitModel[];
  // baseProducts: BaseProductModel[];
  // materials: MaterialModel[];
  // coreOptions: { id: string; name: string }[] = [];
  // baseProductOptions: { id: string; name: string }[] = [];
  baseProductTrialOptions: { id: string; name: string }[] = [];
  hsCodeEnergyOptions = []; // HsCode.getOptions(EProductType.Energy);
  hsCodeElectroOptions = [];
  packingOptions = [];
  cartonSizeOptions = []; //TypeOfCartonBox.getOptions();
  packingSpecOptions = [];
  // hsCodeTemplate = 0;
  downloadType = DownloadType;
  isPreview = false;

  typeOptions = [
    { id: EProductType.Energy, name: 'Energy materials' },
    { id: EProductType.Electro, name: 'Electro machinery' },    { id: 'code', name: 'Code', search: '' },

  ];
  energyType = EProductType.Energy;
  electroType = EProductType.Electro;
  boxLabelPriorityOptions = BoxLabelPriorityData.getOptions();

  public search: string;
  public column: string;

  columnOptions = [
    { id: '', name: 'in all columns' },
    { id: 'nameOverride', name: 'Product name', search: '' },
    { id: 'code', name: 'Product code', search: '' },
    { id: 'product', name: 'Base product', search: '' },
    // { id: 'businessUnit', name: 'Business unit', search: '' },
    { id: 'customers', name: 'Customers', search: '' },
    { id: 'suppliers', name: 'Suppliers', search: '' },
    // { id: 'hs', name: 'HS code', search: '' },
    { id: 'externalCode', name: 'Customer code', search: '' },
    { id: 'width', name: 'width (mm)', search: '' },
    { id: 'rollLength', name: 'Roll length (m)', search: '' },
    { id: 'core', name: 'Core', search: '' },
    { id: 'updatedAt', name: 'Date', search: '' },
  ];
  columns = this.columnOptions.splice(1);

  countryOptions = CountryCodes.getOptions();
  statusOptions = FinishedProductStatus.getOptions();
  statusFilterOptions = [{id: 0, name: 'all'}, ...FinishedProductStatus.getOptions()];
  statusFilter = 0;

  buFilterOptions: { id: string, name: string }[]
  buFilter = null;

  // subscriptions: Subscription[] = [];

  productRouteCreated = false;

  p: number;

  constructor(
    public api: ApiService,
    public data: SharedDataService,
    protected toastrService: NbToastrService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected dialogService: NbDialogService,
    public auth: AuthGuardService,
  ) {
    super(dialogService, api, auth,data);
  }

  ngOnInit() {

    this.auth.loadMe().then(async user => {
      this.readOnly = user.erpRoles.readOnlyProducts;

      await this.loadData();
      if (this.route.snapshot.queryParams['product']
                            && !this.productRouteCreated) {
        // this.create();
        // const product = this.route.snapshot.queryParams['product'];
        // this.selected.product = product;
        // const customer = this.route.snapshot.queryParams['customer'];
        // const supplier = this.route.snapshot.queryParams['supplier'];
        // if (customer) this.selected.customers = [JSON.parse(customer)];
        // if (supplier) this.selected.suppliers = [JSON.parse(supplier)];
        // this.selected.type = this.isEnergy(mongoId(this.selected.product))
        //   ? EProductType.Energy : EProductType.Electro;
        // this.hsCodeOptions = HsCode.getOptions(this.selected.type);
        // this.productRouteCreated = true;
        // this.selected.version = 1;
        // this.dirtyString = JSON.stringify(this.selected);
        const product = this.route.snapshot.queryParams['product'];
        const customer = this.route.snapshot.queryParams['customer'];
        const supplier = this.route.snapshot.queryParams['supplier'];
        console.log('create finished product', this.route.snapshot);
        this.createFromBaseProduct(product, customer && JSON.parse(customer), supplier && JSON.parse(supplier));
      } else if (this.route.snapshot.queryParams['code']
                            && !this.productRouteCreated) {
        this.selected = this.items.find(f =>
          f.code === this.route.snapshot.queryParams['code']
        );
        this.lock();
        this.toggleSidebar(this.selected);
        this.productRouteCreated = true;

      }

      console.log('shelf init', this.selected, this.finishedProduct);

      this.initializecarton();

    });


  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    console.log('shelf changes', changes);
    if (changes.finishedProduct && changes.finishedProduct.currentValue) {
      await waitForVariable(this, 'items');
      this.selected = this.items.find(f =>
        f.code === this.finishedProduct.code
      );
      this.lock();
      this.toggleSidebar(this.selected);

      this.initializecarton();

    } else if (changes.baseProduct && changes.baseProduct.currentValue) {

      await waitForVariable(this, 'items');
      this.createFromBaseProduct(mongoId(this.baseProduct), this.baseProduct.customer, this.baseProduct.supplier);
    }

    // console.log('selected product', this.selected.product)
  }

  // sideBarOpened() {
  //   this.hsCodeOptions = HsCode.getOptions(this.selected.type);
  // }

  createFromBaseProduct(baseProduct, customer, supplier) {
    this.create();
    this.selected.product = baseProduct;
    if (customer) this.selected.customers = customer ? [customer] : [];
    this.selected.suppliers = supplier ? [supplier] : [];
    this.selected.type = this.isEnergy(mongoId(this.selected.product))
      ? EProductType.Energy : EProductType.Electro;
    // this.hsCodeOptions = HsCode.getOptions(this.selected.type);
    this.productRouteCreated = true;
    this.selected.version = 1;
    this.dirtyString = JSON.stringify(this.selected);
    this.initializecarton();
  }

  initializecarton() {

    if (!this.selected) return;

    console.log('initialize carton', this.selected.piecesPerCarton, this.selected.cartonSize)

    if (!this.selected.cartonSize?.length) {
      this.selected.cartonSize = [null, null, null];
    }
    if (!this.selected.piecesPerCarton?.length) {
      this.selected.piecesPerCarton = [null, null, null];
    }
    if (!this.selected.packingSpec?.length) {
      this.selected.packingSpec = [null, null, null];
    }

    console.log('shelf', this.selected);

    this.cartonSizeChanged(this.selected.cartonSize[0],  0);
    this.cartonSizeChanged(this.selected.cartonSize[1],  1);
    this.cartonSizeChanged(this.selected.cartonSize[2],  2);

    if (this.selected.product?.shelfLife20Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.Standard20Deg).name = `Standard Shelf Life 20°C (${this.selected.product.shelfLife20Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryColumn20Deg).name = `Expiry Column Shelf Life 20°C (${this.selected.product.shelfLife20Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryCalculation20Deg).name = `Expiry Calculation Shelf Life 20°C (${this.selected.product.shelfLife20Deg} Months)`;
    }
    if (this.selected.product?.shelfLife10Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.Standard10Deg).name = `Standard Shelf Life 10°C (${this.selected.product.shelfLife10Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryColumn10Deg).name = `Expiry Column Shelf Life 10°C (${this.selected.product.shelfLife10Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryCalculation10Deg).name = `Expiry Calculation Shelf Life 10°C (${this.selected.product.shelfLife10Deg} Months)`;
    }
    if (this.selected.product?.shelfLife5Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.Standard5Deg).name = `Standard Shelf Life 5°C (${this.selected.product.shelfLife5Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryColumn5Deg).name = `Expiry Column Shelf Life 5°C (${this.selected.product.shelfLife5Deg} Months)`;
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryCalculation5Deg).name = `Expiry Calculation Shelf Life 5°C (${this.selected.product.shelfLife5Deg} Months)`;
    }

    if (this.selected.product?.shelfLifeFromDispatch20Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryFromDispatch20Deg).name = `Expiry Calculation From Date of Dispatch 20°C (${this.selected.product.shelfLifeFromDispatch20Deg} Months)`;
    }
    if (this.selected.product?.shelfLifeFromDispatch10Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryFromDispatch10Deg).name = `Expiry Calculation From Date of Dispatch 10°C (${this.selected.product.shelfLifeFromDispatch10Deg} Months)`;
    }
    if (this.selected.product?.shelfLifeFromDispatch5Deg) {
      this.boxLabelPriorityOptions.find(f => f.id === EBoxLabelPriority.ExpiryFromDispatch5Deg).name = `Expiry Calculation From Date of Dispatch 5°C (${this.selected.product.shelfLifeFromDispatch5Deg} Months)`;
    }

    console.log('initialize carton', this.selected.piecesPerCarton, this.selected.cartonSize)

  }

  async loadData(reload = false) {
    // this.subscriptions.forEach(s => s.unsubscribe());

    // return new Promise(resolve => {

    //   this.subscriptions.push(this.api.reloadBusinessUnits().subscribe(async _bu => {
    //     this.businessUnits = _bu;
    //     this.buFilterOptions = BusinessUnitUtil.getBusinessUnitOptions(_bu, this.readOnly);

    //     this.cores = await this.api.loadCores();
    //     this.coreOptions = this.cores.map(core => ({ id: core._id, name: core.name}))
    //       .sort((a, b) => (a.name < b.name) ? -1 : 1);

    //     // this.baseProducts = await this.api.loadBaseProducts();
    //     await this.data.loadProducts();
    //     this.baseProducts = this.data.baseProducts;
    //     this.baseProductOptions = this.getCurrentItems(this.baseProducts).map(bp => {
    //       const name = bp ? bp.name : '';
    //       const trial = bp && bp.trial && bp.trial.length > 0 ? ' [' + bp.trial + ']' : '';
    //       return { id: bp._id, name: name + trial };
    //     }).sort((a, b) => (a.name < b.name) ? -1 : 1);
    //     this.baseProductTrialOptions = this.getCurrentItems(this.baseProducts).map(bp => {
    //       const trial = bp ? bp.trial : '';
    //       const name = bp && bp.name && bp.name.length > 0 ? ' [' + bp.name + ']' : '';
    //       return { id: bp._id, name: trial + name};
    //     }).sort((a, b) => (a.name < b.name) ? -1 : 1);

    //     // this.api.preloadBusiness(false).then(_businesses => {
    //     //   this.data.businesses = _businesses;
    //     //   this.data.businessOptions = _businesses.map(m => ({ id: m._id, name: m.name }));
    //     // })

    //     if (!reload) await this.loadItems();

    //     this.items.forEach(i => this.setType(i)); // override type field (now determined by base product)

    //     resolve(true);
    //   }));
    // })

    this.data.loadCompilationData();
    this.data.loadBusinesses();
    await this.data.loadBusinessUnits().then(bu => {
      this.buFilterOptions = BusinessUnitUtil.getBusinessUnitOptions(bu, this.readOnly);
    });
    await this.data.loadMaterials();
    this.data.loadCores();
    await this.data.loadProducts().then(p => {
      this.baseProductTrialOptions = this.getCurrentItems(this.data.baseProducts).map(bp => {
        const trial = bp?.trial || '';
        const name = (bp.name?.length > 0 && bp.name) || '';
        return { id: bp._id, name: `${name} [${trial}]` };
      }).sort((a, b) => (a.name < b.name) ? -1 : 1);
      if (!reload) this.loadItems();
    });

    await this.data.loadCompilationData();

    this.packingOptions = [{ id: null, name: '' }, ...this.data.packingOptions];
    this.cartonSizeOptions = [{ id: null, name: '' }, ...this.data.cartonBoxOptions];

    this.hsCodeEnergyOptions = [{ id: null, name: '' }, ...this.data.compilationData.hsCode
      .filter(f => f.type === EProductType.Energy)
      .map(m => ({ id: m.code, name: m.code + (m.text ? ` (${m.text})` : '') }))];
    this.hsCodeElectroOptions = [{ id: null, name: '' }, ...this.data.compilationData.hsCode
      .filter(f => f.type === EProductType.Electro)
      .map(m => ({ id: m.code, name: m.code + (m.text ? ` (${m.text})` : '') }))];

  }

  cartonSizeChanged(cs, num) {
    
    if (cs) this.packingSpecOptions[num] = this.data.packingOptions.filter(f => new RegExp(cs).test(f.name));
    console.log('cartonSizeChanged', this.data.packingOptions, cs, this.packingSpecOptions);
  }

  // ngOnDestroy(): void {
  //   for (const subscription of this.subscriptions) {
  //     subscription.unsubscribe();
  //   }
  // }

  async loadItems(reload = false) {
    if (reload) {
      await this.data.reloadProducts();
    }
    this.items = super.getItems(this.data.finishedProducts) as FinishedProductModel[];
    if (this.readOnly) {
      this.items = this.items.filter(f => !f.draft);
    }
    this.displayItems = this.getCurrentItems(this.items, true);
  }

  getBaseProductString(product: BaseProductModel): string {
    const id = mongoId(product);
    return this.baseProductTrialOptions.find(f => f.id === id)?.name;
    // const bp = baseProduct || this.findBaseProduct(id);
    // const name = bp ? bp.name : '';
    // const trial = bp && bp.trial && bp.trial.length > 0 ? ' [' + bp.trial + ']' : '';
    // console.log('--getBaseProductString', name+trial, id, bp, name, trial, baseProduct);
    // return name + trial;
  }

  getCoreString(id: string): string {
    const c = this.findCore(id)
    return c && c.name ? c.name : '';
  }

  getBusinessString(id: string): string {
    const b = this.findBusiness(id);
    return b && b.name ? b.name : '';
  }

  changeCore(id) {
    const c = this.findCore(id);
    this.selected.content.energy.core = c;
    this.selected.content.energy.width = this.selected.content.energy.core.width;
  }

  // getCalcCode(item: FinishedProductModel): string {
  //   const bp = item.product ? this.findBaseProduct(item.product.toString()) : null;
  //   const _bu = bp && this.data.businessUnits && this.data.businessUnits.find(f => f._id === mongoId(bp.businessUnit));
  //   const bu = _bu && _bu.code ? _bu.code : 'X';
  //   const mat = bp && bp.material ? bp.material.code : '000';
  //   const code = item.code;
  //   const calcCode = bu + '-' + mat + '-' + code;
  //   item.calcCode = calcCode;
  //   return calcCode;
  // }

  getProductName(item: FinishedProductModel): string {
    const product = item.product ? this.findBaseProduct(mongoId(item.product)) : null;
    const w = ''+(item.content && item.content.energy ? item.content.energy.width : 0);
    const rl = ''+(item.content && item.content.energy ? item.content.energy.rollLength : 0);
    const area = [0,0,0,0].splice(w.length).join('') + w + 'x' + [0,0,0,0].splice(rl.length).join('') + rl;
    const core = item.content && item.content.energy && item.content.energy.core ?
      item.content.energy.core.name : '0-0-0'
    let name = (product ? product.name : '')
      + (item.type === EProductType.Energy ? '; ' + area + '-' + core : '');
    name = item.nameOverride ? item.nameOverride : name;
    item.calcName = name;
    return name + ` (${this.getVersionString(item)})`
  }

  getCustomerProductName(item: FinishedProductModel) {
    if (item.type === EProductType.Electro && item.content) {
      return item.content.electro;
    }
    const code = '';
    const bp = this.findBaseProduct(item.product.toString());
    const name = bp ? bp.name + '; ' : '';
    const dim = item.content && item.content.energy.core ?
      item.content.energy.width + '/'
                  + item.content.energy.rollLength + '/'
                  + this.findCore(item.content.energy.core.toString()).name
      : '';
    return code + name + dim;
  }

  // getTypeString(item: FinishedProductModel /* id: string */) {
  //   const bp = item.product && this.baseProducts && this.baseProducts.find(f => f._id === mongoId(item.product));
  //   const bu =  bp && bp.businessUnit && this.businessUnits
  //     && this.businessUnits.find(f => f._id === mongoId(bp.businessUnit));
  //   return bu && bu.name;
  // }

  getBusinessUnit(item: FinishedProductModel) {
    const bp = item.product && this.data.baseProducts && this.data.baseProducts.find(f => f._id === mongoId(item.product));
    return bp && bp.businessUnit;
  }

  getTDS(bp: BaseProductModel) {
    // const item = this.data.baseProducts.find(f => f._id === bp);
    const tds = bp?.technicalDatasheets?.filter(f => f.checked);
    return tds;
  }

  async downloadTDS(bp: BaseProductModel) {
    for (const tds of this.getTDS(bp)) {
      await this.api.downloadFile(tds);
    }
  }

  findCore(id: string): CoreModel {
    return this.data.cores?.find(s => s._id.toString() === id)
  }

  findBaseProduct(id: string): BaseProductModel {
    return this.data.baseProducts?.find(s => s._id.toString() === id)
  }

  findBusiness(id: string): BusinessModel {
    return this.data.businesses?.find(s => s._id.toString() === id)
  }

  productChanged(id: string) {
    this.selected.type = this.isEnergy(mongoId(id)) ? EProductType.Energy : EProductType.Electro;
    // this.typeChanged(this.selected.type);
  }

  async gotoBaseProduct(item: FinishedProductModel, baseProduct: BaseProductModel = null) {
    if (await this.canDismiss(item)) {
      const bp = baseProduct || (item && this.data.baseProducts.find(p => p._id === mongoId(item.product)));
      if (this.fromWizard) {
        this.wizardAction.emit(new WizardAction(EWizardAction.showBaseProduct, bp))
      } else {
        this.router.navigate(
          ['/pages/erp/base-product'],
          // { queryParams: {id: item.product} }
          { queryParams: {code: bp?.code } }
        );
      }
    }
  }

  setType(item: FinishedProductModel) {
    if (item.product) {
      item.type = this.isEnergy(mongoId(item.product)) ? EProductType.Energy : EProductType.Electro;
    }
  }

  isEnergy(id: string) {
    // TODO: return bu  by code;
    const bp = this.data.baseProducts.find(f => f._id === id);
    const bu = bp && this.data.businessUnits && this.data.businessUnits.find(f => f._id === mongoId(bp.businessUnit))
    return bu && bu.name.match(/energy materials/i);
  }

  async validate(item: FinishedProductModel): Promise<boolean> {
    let valid: boolean = true;
    if (item?.content?.energy?.core?.name !== 'No') {
      if (!/^CO/.test(item.calcCode) && item.type === this.energyType && (!item.content.energy.rollLength
          || (isNaN(+item.content.energy.rollLength)
          || +item.content.energy.rollLength < 0))) {

        this.toastrService.danger('[Roll length] Numeric value >= 0 is required', 'Validation Error');
        valid = false;
      }
      if (!/^CO/.test(item.calcCode) && item.type === this.energyType && (!item.content.energy.width
        || (isNaN(+item.content.energy.width)
        || +item.content.energy.width < 0))) {

        this.toastrService.danger('[Width] Numeric value >= 0 is required', 'Validation Error');
        valid = false;
      }
    }
    if (item.type === this.energyType && +item.status !== FinishedProductStatus.get('Sample').id
      && (isNaN(+item.piecesPerCarton?.[0]) || +item.piecesPerCarton?.[0] < 0)
      && item.piecesPerCarton !== null && item.piecesPerCarton !== undefined) {
      this.toastrService.danger('[Pieces per carton] Numeric value >= 0 is required', 'Validation Error');
      valid = false;
    }
    if (!/^CO/.test(item.calcCode) && item.type === this.energyType && !item.content.energy.core) {
      this.toastrService.danger('[Core] is required', 'Validation Error');
      valid = false;
    }
    if (!item.product) {
      this.toastrService.danger('[Base Product] is required', 'Validation Error');
      valid = false;
    }
    if (!item.changelog || item.changelog === '') {
      this.toastrService.danger('[Changelog comment] is required', 'Validation Error');
      valid = false;
    }
    return valid;
  }

  // edit() {
  //   this.locked = false;
  // }

  clearFilter() {
    this.columns.forEach(el => el.search = '');
    this.statusFilter = 0;
    this.buFilter = null;
  }

  filter() {
    // console.log('buFilter', this.buFilter, 'statusFilter', this.statusFilter);
    this.displayItems = this.displayItems.map((item, index) => ({ item, index }))
      .sort((a, b) => {
        const ac = this.getItemString(a.item, this.sort.column);
        const bc = this.getItemString(b.item, this.sort.column);
        if (ac === bc) return a.index - b.index;  // stable sort
        if (typeof ac === 'number' && typeof bc === 'number') {
          return ac > bc ? this.sort.dir : -this.sort.dir;
        }
        return this.sort.dir * (ac || '').toLowerCase().localeCompare((bc || '').toLowerCase());
      })
      .map(({item}) => item);
    let ret = this.displayItems;
    this.columns.forEach(col => {
      const s = col.search.toLowerCase();
      if (col.search.length) {
        switch (col.id) {
          case 'nameOverride': ret = ret.filter(field =>
            (field && this.getProductName(field).toLowerCase().includes(s)));
            break;
          case 'code': ret = ret.filter(field =>
            (field.calcCode?.toLowerCase().includes(s)));
            break;
          case 'product': ret = ret.filter(field =>
            (field.product && this.getBaseProductString(field.product).toLowerCase().includes(s)));
            break
          case 'businessUnit': ret = ret.filter(field => {
            const bp = this.data.baseProducts.find(f => f._id === mongoId(field.product));
            return (bp && bp.businessUnit && this.data.businessUnits
              && this.data.businessUnits.find(f =>
                f._id === mongoId(bp.businessUnit) && f.name.toLowerCase().includes(s)
              ))
          });
            break;
          case 'customers':
          case 'suppliers':
            ret = ret.filter(field =>
              field[col.id] && field[col.id].map((m: BusinessField) => {
                const b = this.data.businesses.find(f => f._id === m.id);
                return b && b.name
              }).join('.').toLowerCase().includes(s)
            );
            break;
          case 'width': ret = ret.filter(field =>
            (field.content && field.content.energy && field.content.energy.width
              && field.content.energy.width.toString().includes(s)));
            break;
          case 'rollLength': ret = ret.filter(field =>
            (field.content && field.content.energy && field.content.energy.rollLength
              && field.content.energy.rollLength.toString().includes(s)));
            break;
          case 'core': ret = ret.filter(field =>
            (field.content && field.content.energy &&
                          field.content.energy.core &&
                          this.getCoreString(mongoId(field.content.energy.core)).toLowerCase().includes(s)));
            break;
          default:
            ret = ret.filter(field => this.filterItem(field, col.id, s));
        }
      }
    });
    ret = +this.statusFilter ? ret.filter(f => +f.status === +this.statusFilter) : ret;
    ret = this.buFilter && this.buFilter !== 'null' ? ret.filter(f => mongoId(this.getBusinessUnit(f)) === this.buFilter) : ret;
    return this.readOnly ?
      ret.filter(f => BusinessUnitUtil.readOnlyFilter(this.data.businessUnits, this.getBusinessUnit(f))) : ret;
  }

  getItemString(item, col) {
    switch (col) {
      case 'nameOverride':
        return this.getProductName(item);
      case 'businessUnit':
        const bup = this.data.baseProducts.find(f => f._id === mongoId(item.product));
        const bu = bup && bup.businessUnit && this.data.businessUnits.find(f => f._id === mongoId(bup.businessUnit));
        return bu && bu.name;
      case 'suppliers':
      case 'customers':
        // sort by first entry of customers / suppliers
        const b = item[col] && item[col][0] && this.data.businesses.find(f => f._id === mongoId(item[col][0].id));
        return b && b.name;
      case 'project':
        const bp = item[col] && this.data.baseProducts.find(f => f._id === mongoId(item[col]));
        return bp && bp.name;
      case 'core':
        return item.content && item.content.energy && item.content.energy.core
          && this.getCoreString(mongoId(item.content.energy.core))
      case 'width':
      case 'rollLength':
        return item.content && item.content.energy && +item.content.energy[col];
      default: return item[col] || '';
    }
  }

  onSort(col) {
    super.onSort(col);
  }

  async onPackingChanged(packing: any) {
    console.log('on packing changed', packing, this.selected.cartonSize, this.data, this.data?.getPackingConfig(packing));
    const fpd = this.data?.getPackingConfig(packing);
    if (!this.selected.cartonSize) this.selected.cartonSize = [];
    this.selected.cartonSize[0] = fpd?.cartonBox;
  }

  create(item: FinishedProductModel = null, clone = false) {
    super.create();
    if (item && clone) {
      this.selected = Object.assign({}, item);
    } else {
      this.selected = new FinishedProductModel();
      this.selected.type = EProductType.Energy;
      this.selected.content = new FpContent();
      this.selected.content.energy = new FpEnergy();
    }
    this.selected.version = 0;

    // code is set in backend (this is only preview)!
    const code = this.items.length ?
      '' + (1 + this.items.map(m => +m.code || 0).reduce((a, b) => Math.max(a, b))) : '1';
    this.selected.code = [0,0,0,0,0,0,0,0,0].splice(code.length).join('') + code;
    this.selected.draft = true;
    this.lock(false);
    this.initializecarton();
  }

  async cancelDraft(item: FinishedProductModel) {
    if (item._id && item.draft) await this.api.deleteFinishedProduct(item);
    super.cancelDraft(item);
  }

  handleError(err) {
    console.error(err, err.error, err.error?.errors);
    let msg = err.error?.errmsg || err.error?.message || err.headers?.message;
    if (err.error?.keyValue && err.error.code === 11000 && err.error.keyValue.code) {
      msg = `Document ${err.error.keyValue.code} version ${err.error.keyValue.version} already exists`;
    }
    this.toastrService.danger(msg, 'Error');
  }

  async saveItem(item: FinishedProductModel, draft: boolean = false): Promise<FinishedProductModel> {
    console.log('save finished product', item);
    try {
      await this.saveChangelog(item);
      this.selected.cartonSize = this.selected.cartonSize?.filter(notNull => notNull);
      this.selected.piecesPerCarton = this.selected.piecesPerCarton?.filter(notNull => notNull);
      this.selected.packingSpec = this.selected.packingSpec?.filter(notNull => notNull);
      const id = (await this.api.saveFinishedProduct(item))?._id;
      const s = `FinishedProduct '${item.calcName}' saved!`;
      this.toastrService.success(s, 'Success');
      await this.loadItems(true);
      // item = await super.reload(item);
      // item._id = id;
      item = this.data.finishedProducts.find(f => mongoId(f) === id);
      // const product = this.baseProducts.find(f => f._id === mongoId(item.product));
      // if (!draft) this.api.downloadFinishedProductPDF(item, product);
      if (this.fromWizard) this.finishedProduct = item
      // await this.data.reloadProducts();
      this.updatePriceMatrix(item);
    } catch (err) {
      this.handleError(err);
      this.locked = false;
      item.draft = false;
    }
    return item;
  }

  async updatePriceMatrix(item: FinishedProductModel) {
    const matrices = [...await this.api.loadPriceMatrix(IssuerData.get('nrka').id),
      ...await this.api.loadPriceMatrix(IssuerData.get('nrkg').id)];
    item && super.getVersions(item).forEach(el => {
      matrices.forEach(m => {
        if (mongoId(item) !== mongoId(el)) {
          if (mongoId(m.finishedProduct) === mongoId(el)) {
            m.finishedProduct = mongoId(item);
            this.api.updateFinishedProductOfPriceMatrix(m);
          }
        }
      })
    });
  }

  async pdfPreview(item: FinishedProductModel, type: DownloadType = DownloadType.document) {
    if (this.validate(item)) {
      if (!item._id) {
        item = await this.save(item, true);
      }
      const product = this.data.baseProducts.find(f => f._id === mongoId(item.product));
      this.api.downloadFinishedProductPDF(item, product, type);
    }
  }

  async priceMatrix(item: FinishedProductModel, issuer: string) {
    if (this.fromWizard) {
      // if (this.baseProduct) await this.saveItem(this.finishedProduct);
      // console.log('before pm', item, issuer);
      this.wizardAction.emit(new WizardAction(EWizardAction.showPriceMatrix, item))
    } else {
      this.router.navigate(
        [`pages/erp/price-matrix/${issuer}/finished-product`],
        // { queryParams: { finishedProduct: item._id, business: item.business } }
        { queryParams: {
          finishedProduct: item._id,
          customers: item.customers.map(m => m.id),
          suppliers: item.suppliers.map(m => m.id),
        }}
      );
    }
  }

  // public typeChanged(item: EProductType) {
  //   this.hsCodeOptions = HsCode.getOptions(Number(item));
  // }

  // public hsChanged(item) {
  //   this.selected.hs = HsCode.get(Number(item)).code;
  //   this.hsCodeTemplate = 0;
  // }

  async toggleDisable(item: FinishedProductModel) {
    item.disabled = !item.disabled;
    await this.api.toggleDisableFinishedProduct(item.code, item.disabled);
  }

  setFinishedProduct() {
    this.wizardAction.emit(new WizardAction(EWizardAction.finalize,  mongoId(this.finishedProduct)));
  }

  moveFilesToSpec(idx: number) {
    this.selected.customerProductSpecification = [...(this.selected.customerProductSpecification || []), ...this.selected.files.splice(idx, 1)];
  }

  previousFinishedProduct() {
    console.log('finished products', this.data.finishedProducts, mongoId(this.selected));
    const fps = this.data.finishedProducts.filter(f => mongoId(f.product) === mongoId(this.selected.product));
    let idx = fps.findIndex(f => mongoId(f) === mongoId(this.selected)) - 1;
    if (idx !== -2) {
      if (idx < 0) idx = fps.length - 1;
      this.select(fps[idx]);
      this.initializecarton();
    }
  }

  async nextFinishedProduct() {
    console.log('finished products', this.data.finishedProducts, mongoId(this.selected));
    const fps = this.data.finishedProducts.filter(f => mongoId(f.product) === mongoId(this.selected.product));
    let idx = fps.findIndex(f => mongoId(f) === mongoId(this.selected)) + 1;
    if (idx !== 0) {
      if (idx >= fps.length) idx = 0;
      this.select(fps[idx]);
      this.initializecarton();
    }
  }

}
